import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useToast } from "@/hooks/use-toast";
import NPOProfileCompletion from "./NPOProfileCompletion";
import HostProfileCompletion from "./HostProfileCompletion";
import CorporateProfileCompletion from "./CorporateProfileCompletion";

const VerificationPending = ({ session, profile }: { session: any; profile: any }) => {
  const navigate = useNavigate();
  const { toast } = useToast();
  
  useEffect(() => {
    console.log(profile);
    if(session?.user) {
      if(session.user.user_metadata.verification_status === 'approved') {
        toast({
          title: "Account Verified",
          description: "Your account has been verified. Redirecting to dashboard...",
          duration: 3000,
        });
        navigate("/dashboard");
        return
      }
    }
  }, [session, profile]);

  return profile?.user_type === 'nonprofit' ? <NPOProfileCompletion session={session} profile={profile} /> : (profile?.user_type === 'host' ? <HostProfileCompletion session={session} profile={profile} /> : <CorporateProfileCompletion session={session} profile={profile} /> );
};

export default VerificationPending;